import { useMutation } from 'react-query';
import { toast } from 'react-toastify';
import { httpService } from '../../services/http.service';
import { BASE_URL } from '../../constants/endpoints';
import { flattenServerErrorResponse } from '../../helpers/errors.helper';
import { IServerErrorResponse } from '../../types';

interface IProps {
    customerId: string;
    optionType: string;
    link: string;
    onSuccess: (data: any) => void;
}

export const useUpdatePaymentOptionMutation = ({
  customerId, optionType, link, onSuccess,
}: IProps) => useMutation(
  'UpdatePaymentOption',
  async () => {
    const { data } = await httpService.post(`${BASE_URL}/api/v1/user/${customerId}/paymentOptions/update`, {
      optionType,
      link,
    });
    return data;
  },
  {
    retry: 1,
    onSuccess: (data: any) => {
      onSuccess(data);
    },
    onError: (e:IServerErrorResponse) => {
      const { localizedMessage, message } = flattenServerErrorResponse(e);
      toast.error(localizedMessage || message || 'Please try again.', {
        position: 'bottom-center',
        autoClose: 3500,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: 'colored',
      });
    },
  },
);
